module.exports = __webpack_public_path__ + "static/media/img_ai_04.932ec4d2.png";